import { useId, useState } from 'react'
import { EyeIcon, EyeOffIcon } from '@/components/icons'
import { IconButton } from './IconButton'
import { FieldShell } from './internal/FieldShell'
import { describedBy } from './internal/cx'

export type PasswordFieldProps = {
  label: string
  value: string
  onChange: (value: string) => void
  error?: string
  hint?: string
  required?: boolean
  placeholder?: string
  autoComplete?: string
  disabled?: boolean
  onBlur?: () => void
  id?: string
}

/** TextField with a built-in show/hide eye toggle inside the control. */
export function PasswordField({
  label,
  value,
  onChange,
  error,
  hint,
  required = false,
  placeholder,
  autoComplete = 'current-password',
  disabled = false,
  onBlur,
  id,
}: PasswordFieldProps) {
  const autoId = useId()
  const fieldId = id ?? autoId
  const [visible, setVisible] = useState(false)

  return (
    <FieldShell id={fieldId} label={label} required={required} error={error} hint={hint}>
      <div className="ui-password">
        <input
          id={fieldId}
          className="ui-input"
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          required={required}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(error && `${fieldId}-error`, !error && hint && `${fieldId}-hint`)}
        />
        <span className="ui-password__toggle">
          <IconButton
            aria-label={visible ? 'Verberg wachtwoord' : 'Toon wachtwoord'}
            onClick={() => setVisible((current) => !current)}
            disabled={disabled}
          >
            {visible ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
          </IconButton>
        </span>
      </div>
    </FieldShell>
  )
}
